module.exports = __webpack_public_path__ + "img/formacionLaboral.f128e9d4.jpg";